export default __webpack_public_path__ + "assets/images/g-icon1-8c4a101c.svg";